import { render, staticRenderFns } from "./RateMealPlanBanner.vue?vue&type=template&id=050ccab5&scoped=true"
import script from "./RateMealPlanBanner.vue?vue&type=script&lang=js"
export * from "./RateMealPlanBanner.vue?vue&type=script&lang=js"
import style0 from "./RateMealPlanBanner.vue?vue&type=style&index=0&id=050ccab5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ccab5",
  null
  
)

export default component.exports